

import { useLazyQuery } from "@apollo/client/react";
import { useState } from "react";
import { GET_RESULTADOS_CONSULTA } from "../../../data/graphQL/queries/ConsultasGenerales/getResultadoConsulta";
import toast from "react-hot-toast";
import { downloadExcel } from "../../../utils/downloadExcel";
import moment from "moment";
import { downloadCsv } from "../../../utils/downloadCsv";

export const useGetResultadosConsulta = () => {
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [getResultadosQuery] = useLazyQuery(GET_RESULTADOS_CONSULTA);

    const validarFiltros = (consultaSelected, selectedDelegaciones, parametros, parametrosValues) => {
        if (!consultaSelected?.id) {
            toast.error("Debe seleccionar una consulta");
            return false;
        }

        if (!selectedDelegaciones || selectedDelegaciones.length === 0) {
            toast.error("Debe seleccionar al menos una delegación");
            return false;
        }

        if (parametros && parametros.length > 0) {
            const parametrosFaltantes = parametros.filter(parametro =>
                !parametrosValues[parametro.name] || parametrosValues[parametro.name] === ''
            );

            if (parametrosFaltantes.length > 0) {
                toast.error(`Los siguientes parámetros son requeridos: ${parametrosFaltantes.map(p => p.displayName).join(', ')}`);
                return false;
            }
        }

        return true;
    };

    const ejecutarConsulta = async (consultaSelected, selectedDelegaciones, parametrosValues, esExportarExcel) => {
        setLoading(true);
        setError(null);

        try {
            const delegacionesString = selectedDelegaciones.map(d => d.id).join(',');

            const input = {
                idConsulta: consultaSelected.id,
                exportExcel: esExportarExcel,
                storedProcedure: consultaSelected.storedProcedure,
                dataPrivacy: consultaSelected.dataPrivacy,
                delegaciones: delegacionesString
            };

            const { data } = await getResultadosQuery({
                variables: {
                    input,
                    filtros: parametrosValues
                }
            });

            const resultadosData = data?.ejecutarSPConsulta || [];
            setResultados(resultadosData);
            return resultadosData;
        } catch (err) {
            const errorMessage = err.message || "Error al ejecutar la consulta";
            setError(errorMessage);
            toast.error(errorMessage);
            setResultados([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const onSearch = async ({ consultaSelected, selectedDelegaciones, parametros, parametrosValues, esExportarExcel }) => {
        if (!validarFiltros(consultaSelected, selectedDelegaciones, parametros, parametrosValues)) {
            return [];
        }

        const resultadosData = await ejecutarConsulta(consultaSelected, selectedDelegaciones, parametrosValues, esExportarExcel);
        if (esExportarExcel) {
            if (resultadosData.length > 0) {
                await generarExcel(resultadosData, consultaSelected?.displayName);
            } else {
                toast.error("No hay datos para exportar");
            }
        }

        return resultadosData;
    };

    const generarExcel = async (data, consultaSelected) => {
    try {
        const headerExcel = Object.keys(data[0] || {});
        const fileName = `consulta_${consultaSelected}_${moment().format('DD_MM_YYYY')}`;
        const tablePayload = { header: headerExcel, body: data };

        const LIMITE_EXCEL = 100_000;

        if (data.length > LIMITE_EXCEL) {
            toast(`El resultado tiene ${data.length} filas. Descargando como CSV...`);
            downloadCsv({ fileName, tablePayload });
        } else {
            downloadExcel({ fileName, sheet: 'Resultados', tablePayload });
        }
    } catch (err) {
        console.error("Error generando Excel:", err);
        toast.error("Error al generar el archivo Excel");
    }
};

    return {
        resultados,
        loading,
        error,
        onSearch,
    };
};